<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong id="pageTitle">Register of Power of Attorney</strong>
        </span>
        <span style="float: right">
            <!-- <a [routerLink]="['/powerofattorneylist']"> -->
                <button (click)="back()"  class="btn btn-sm btn-default pull-right btn-back" type="button">
                    <i class=" fa fa-chevron-circle-left"></i>
                    Back
                </button>
            <!-- </a> -->
        </span>
        <!-- <span style="float:right">
            <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="!addBtn">
              <span>
                <i class="fa fa-save"></i>Generate Output</span>
            </button>
      </span> -->
    </div>


    <form [formGroup]="poaForm" (document:click)="a.close();b.close()">
        <div class="modal-body">
            <div class="row">
                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Particulars of Power of Attorney</label>
                    <textarea class="form-control" [formControl]="poaForm.controls.paticularsofPower" maxlength="200"> </textarea>
                    <div *ngIf="poaForm.controls['paticularsofPower'].hasError('pattern')" class="form-control-error-custom">
                        Particulars of Power of Attorney is invalid
                    </div>
                </div>

                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Name and Designation of the Person in whose favour Power of Attorney is issued </label>
                    <span _ngcontent-c1="" style="color: red;">*</span>
                    <input type="text" class="form-control" [formControl]="poaForm.controls.namedesgnPower">
                    <div *ngIf="poaForm.controls['namedesgnPower'].hasError('pattern')" class="form-control-error-custom">
                        Name and Designation of the Person is invalid
                    </div>
                    <div *ngIf="poaForm.controls['namedesgnPower'].hasError('required') && poaForm.controls['namedesgnPower'].touched" class="form-control-error-custom">
                        Name and Designation of the Person is required
                    </div>
                </div>


                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Date of Board Meeting in which Power of Attorney Approved</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [formControl]="poaForm.controls['dobminPower']" [(ngModel)]="dobminPower" style="padding:6px;z-index: 0;"
                            placeholder="dd-mm-yyyy" name="titledate" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle()">
                        <button class="input-group-addon" (click)="a.toggle()" type="button">
                            <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                        </button>
                    </div>

                </div>

                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Name of the Persons in whose presence common seal affixed in Power of Attorney</label>
                    <input type="text" class="form-control" [formControl]="poaForm.controls.commonsealaffixedPower">
                </div>


                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Date of withdrawal of Power of Attorney</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [formControl]="poaForm.controls['datewithdrawalPower']" [(ngModel)]="datewithdrawalPower" style="padding:6px;z-index: 0;"
                            placeholder="dd-mm-yyyy" name="titledate" ngbDatepicker #b="ngbDatepicker" (click)="b.toggle()">
                        <button class="input-group-addon" (click)="b.toggle()" type="button">
                            <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                        </button>
                    </div>

                </div>


                <div class="form-group col-md-6 col-sm-6 col-xs-12" *ngIf="!fileAvailable">
                    <label>Upload</label>
                    <input type="file" class="form-control" (change)="fileChangeEvent($event)"  accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4">
                    <span style="color: red" *ngIf="!fileExtension">Please upload valid file format.</span>
                </div>

                <div class="form-group col-md-6 col-sm-6 col-xs-12" *ngIf="fileAvailable">
                    <label>Upload </label>
                    <div>
                        <input type="text" data-toggle="tooltip" [title]="poaFileName" [formControl]="poaForm.controls.fileName" [(ngModel)]="poaFileName"
                            readonly='true' class='form-control col-md-8' style="display: inline-block;">
                        <button type="button" class="btn-sm btn btn-primary form-control col-md-1" (click)='downloadCtcDoc(documentManagementID);'>
                            <i class="fa fa-download"></i>
                        </button>
                        <button type="button" class="btn-sm btn btn-primary  form-control col-md-2" (click)='addFilesOnUpdate();'>Add New</button>

                    </div>
                </div>

                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Remarks, if any</label>
                    <div class="input-group">
                        <textarea class="form-control" [formControl]="poaForm.controls.remarks" maxlength="200" ng-model="fact.desc.en"></textarea>
                    </div>
                </div>
            </div>



        </div>
        <div class="card-footer" align="right">
            <!--<div class="form-actions" style="text-align: right">-->
            <button type="button" class="btn-sm btn btn-primary" (click)='showFormEntry();' [disabled]="!poaForm.valid || !fileExtension || disabledOnclick" id="saveBtnAgenda"
                *ngIf="addBtn">
                <i class="fa fa-save"></i>&nbsp;Save</button>
            <!-- <button class="btn btn-sm btn-primary" (click)="generateOutput()" type="button" *ngIf="!addBtn">
                <span>
                    <i class="fa fa-save"></i>Generate Output </span>
            </button> -->
            <button type="button" class="btn-sm btn btn-primary" (click)='updatePoaDetails();' [disabled]="!poaForm.valid || !fileExtension || disabledOnclick" id="saveBtnAgenda"
                *ngIf="!addBtn">
                <i class="fa fa-save"></i>&nbsp;Update</button>
            <!--</div>-->
        </div>

    </form>




</section>
<app-alert></app-alert>